export const FAQ_GROUPS = [
  {
    id: 'start',
    title: 'Getting started',
    items: [
      {
        q: 'Can I start for free?',
        a: 'Yes. The Free plan does not require a card. Limits are listed on Pricing and enforced in the product.',
      },
      {
        q: 'How do I sign up?',
        a: 'Start free opens the Business app at /signup. Sign in is for existing accounts.',
      },
      {
        q: 'Where do I sell after I sign up?',
        a: 'Open cevop POS, sign in with the same account, open a session if prompted, and charge. The Business workspace is for stock, buying, sales history, money, reports, and team.',
      },
    ],
  },
  {
    id: 'billing',
    title: 'Plans and billing',
    items: [
      {
        q: 'Is checkout on this website?',
        a: 'No. This site displays catalog prices. Paid billing is completed in the Business app when it is live for your organisation — not on cevop.com.',
      },
      {
        q: 'Are there annual prices?',
        a: 'Annual billing is not a live catalog price yet. The amounts on Pricing are NGN monthly prices from Billing.',
      },
      {
        q: 'Can I use cevop for multiple locations?',
        a: 'Growth includes up to five branches. Enterprise is arranged with sales for unlimited branches and multiple businesses.',
      },
    ],
  },
  {
    id: 'product',
    title: 'Product',
    items: [
      {
        q: 'What is cevop?',
        a: 'cevop is a Business Operating System: a Business workspace plus POS. Operating areas include Home, Stock, Sales, Buying, Money, Registers, and Settings — one connected system, not separate apps for each.',
      },
      {
        q: 'What payment methods can my customers use?',
        a: 'Cashiers can record cash, card, or transfer on POS. cevop stores the method and amount you enter — not card numbers.',
      },
      {
        q: 'Is cevop a restaurant POS?',
        a: 'No. It is a sales POS plus a business workspace for businesses that sell — especially product-selling counters. It does not manage tables, kitchen tickets, or dining areas.',
      },
      {
        q: 'Must every business track physical stock?',
        a: 'No. Products and prices work without warehouse-style stock counts. Turn stock tracking on when you need quantities, movements, and low-stock signals.',
      },
      {
        q: 'Does cevop include AI?',
        a: 'No. cevop is deterministic operational software. Sales, stock, and the ledger are calculated records — not model output.',
      },
    ],
  },
] as const;
